import React, { useState, useRef, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { leftarrow, rightarrow } from "../../colorcoding/svg/iconsvg";
import { calenderIcon, searchIcon } from "../../landingscreen/modals/svgs";
import DateRangeSelector from "../../daterangepicker/DateRangeSelector";

// ✅ Custom styled calendar
const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
  "& .MuiPickersCalendarHeader-label": {
    fontSize: "15px",
  },
  "& .MuiPickersDay-root.Mui-selected": {
    backgroundColor: "#1D2951",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1D2951",
    },
  },
}));
const getWeekRange = (date = dayjs()) => {
  const day = date.day();
  const diff = day === 0 ? -6 : 1 - day; // force Monday
  const start = date.add(diff, "day").startOf("day");
  const end = start.add(6, "day").endOf("day");
  return { startDate: start, endDate: end };
};

const TimesheetSearchBar = ({
  dateRange,
  setDateRange,
  searchTerm,
  setSearchTerm,
  type, // type === 1 → DateRangePicker, otherwise single date
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const calendarRef = useRef(null);

  // ✅ Close calendar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsCalendarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const getLastTwoWeeksRange = (date = dayjs()) => {
  const end = getWeekRange(date).endDate; // end of current week (Sunday)
  const start = end.subtract(13, "day"); // 14 days total
  return { startDate: start.startOf("day"), endDate: end.endOf("day") };
};

  // ✅ When selecting a single date
  const handleDateChange = (newDate) => {
    setDateRange({
      startDate: newDate,
      endDate: newDate,
    });
    setIsCalendarOpen(false);
  };

  // ✅ Apply (Date Range)
  const handleRangeSubmit = () => {
    console.log("Applied Date Range:", dateRange);
    setIsCalendarOpen(false);
  };

  // ✅ Reset (Date Range)
  const handleRangeReset = () => {
    setDateRange({
      startDate: dayjs(),
      endDate: dayjs(),
    });
  };
// const handlePrevDate = (e) => {
//   e.stopPropagation();
//   setDateRange((prev) => ({
//     startDate: prev.startDate.subtract(1, "day"),
//     endDate:
//       type === 1 || type === 2
//         ? prev.endDate.subtract(1, "day")
//         : prev.startDate.subtract(1, "day"),
//   }));
// };
const handlePrevDate = (e) => {
  e.stopPropagation();

  // 🔵 RECAP → move week
  if (type === 1) {
   setDateRange((prev) => ({
    startDate: prev.startDate.subtract(7, "day"),
    endDate: prev.endDate.subtract(7, "day"),
  }));
    return;
  }

  // 🟢 PTO range → move 1 day range
  if (type === 2) {
    setDateRange((prev) => ({
      startDate: prev.startDate.subtract(1, "day"),
      endDate: prev.endDate.subtract(1, "day"),
    }));
    return;
  }

  // ⚪ daily timesheet
  setDateRange((prev) => ({
    startDate: prev.startDate.subtract(1, "day"),
    endDate: prev.startDate.subtract(1, "day"),
  }));
};

const handleNextDate = (e) => {
  e.stopPropagation();

  // 🔵 RECAP → move week
  if (type === 1) {
  setDateRange((prev) => ({
    startDate: prev.startDate.add(7, "day"),
    endDate: prev.endDate.add(7, "day"),
  }));
    return;
  }

  // 🟢 PTO range → move 1 day range
  if (type === 2) {
    setDateRange((prev) => ({
      startDate: prev.startDate.add(1, "day"),
      endDate: prev.endDate.add(1, "day"),
    }));
    return;
  }

  // ⚪ daily
  setDateRange((prev) => ({
    startDate: prev.startDate.add(1, "day"),
    endDate: prev.startDate.add(1, "day"),
  }));
};

// const handleNextDate = (e) => {
//   e.stopPropagation();
//   setDateRange((prev) => ({
//     startDate: prev.startDate.add(1, "day"),
//     endDate:
//       type === 1 || type === 2
//         ? prev.endDate.add(1, "day")
//         : prev.startDate.add(1, "day"),
//   }));
// };

  return (
    <div className="relative flex flex-wrap items-center gap-4">
      {/* 🔍 Search Input */}
      <div className="relative flex-1 min-w-[250px]">
        <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
          {searchIcon}
        </span>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search Employees"
          className="w-full pl-10 pr-4 py-2 rounded-md border border-[#E5E7EB] bg-white outline-none focus:ring-1 focus:ring-[#1D2951]"
        />
      </div>

      {/* 📅 Calendar / DateRange trigger */}
   <div
  className="flex items-center gap-3 px-4 py-2 rounded-md border border-[#E4E4E7] bg-white text-[#1D2951] cursor-pointer select-none"
  onClick={() => setIsCalendarOpen(!isCalendarOpen)}
>
  {/* ◀ Previous */}
  <div
    onClick={handlePrevDate}
    className="cursor-pointer hover:opacity-70 transition"
  >
    {leftarrow}
  </div>

  {/* Date Text */}
  <span className="text-[#000] font-medium whitespace-nowrap">
    {type === 1 || type === 2
      ? `${dateRange.startDate.format("MMM DD, YYYY")} - ${dateRange.endDate.format(
          "MMM DD, YYYY"
        )}`
      : dateRange.startDate.format("MMM DD, YYYY")}
  </span>
  {/* Calendar Icon */}
  <span className="text-[#000]">{calenderIcon}</span>
  {/* ▶ Next */}
  <div
    onClick={handleNextDate}
    className="cursor-pointer hover:opacity-70 transition"
  >
    {rightarrow}
  </div>


</div>


      {/* 📅 Conditional Calendar / DateRangeSelector */}
      {isCalendarOpen && (
        <div
          ref={calendarRef}
          className={
    type === 1||type === 2
      ? "absolute top-[50px] right-[20%] z-50 p-2"
      : "absolute top-[50px] right-0 z-50 w-[330px] bg-white shadow-lg rounded-xl p-2"
  }
        >
          {type === 1||type === 2 ? (
            // ✅ Show DateRangeSelector when type=1
            <div className="w-[300px]">
              <DateRangeSelector
                onSubmit={handleRangeSubmit}
                selectedDateRange={{
                  startDate: dateRange.startDate.toDate(),
                  endDate: dateRange.endDate.toDate(),
                  key: "selection",
                }}
                setSelectedDateRange={(range) =>
                  setDateRange({
                    startDate: dayjs(range.startDate),
                    endDate: dayjs(range.endDate),
                  })
                }
                handlereset={handleRangeReset}
              />
            </div>
          ) : (
            // ✅ Default single date calendar
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div className="w-[330px]">
                <CustomDateCalendar
                  value={dateRange.startDate}
                  onChange={handleDateChange}
                />
              </div>
            </LocalizationProvider>
          )}
        </div>
      )}
    </div>
  );
};

export default TimesheetSearchBar;
